import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import NotificationCard from "../shared/NotificationCard";
import { mapAlertToSeverity } from "../shared/severityMappers";

const getAlertIcon = (alertArrow) => {
  const arrow = (alertArrow || "").toLowerCase();

  if (arrow === "up") return <TrendingUpIcon fontSize="small" />;
  if (arrow === "down") return <TrendingDownIcon fontSize="small" />;

  return <ErrorOutlineIcon fontSize="small" />;
};

const getSalesGroupFromAlert = (a) => {
  if (!a) return "";
  return (
    (a.SALES_GROUP && String(a.SALES_GROUP)) ||
    (a.sales_group && String(a.sales_group)) ||
    (a.SalesGroup && String(a.SalesGroup)) ||
    (a.raw && (a.raw.SALES_GROUP || a.raw.sales_group)) ||
    ""
  );
};

function flattenKpiAlerts(alerts, selectedProduct, selectedSalesGroup) {
  if (!alerts || !selectedProduct) return [];

  const flattened = [];
  const regions = Object.keys(alerts || {});

  regions.forEach((region) => {
    const regionObj = alerts[region] || {};

    if (selectedProduct === "All") {
      const productKeys = Object.keys(regionObj || {});
      productKeys.forEach((prodKey) => {
        const productAlertsRaw = regionObj[prodKey] || [];

        const productAlertsFiltered =
          selectedSalesGroup && selectedSalesGroup !== "All"
            ? productAlertsRaw.filter((a) =>
                getSalesGroupFromAlert(a)
                  .toString()
                  .toUpperCase()
                  .includes(selectedSalesGroup.toString().toUpperCase()),
              )
            : productAlertsRaw;

        productAlertsFiltered.forEach((a, idx) => {
          flattened.push({
            id: `${region}-${prodKey}-${idx}`,
            severity: mapAlertToSeverity(a),
            alertArrow: a.AlertArrow || "",
            description:
              a.AlertMessage || a.alertMessage || a.description || "",
            metric: a.metric ?? null,
            salesGroup: getSalesGroupFromAlert(a) || null,
            raw: a,
            region,
            product: prodKey,
          });
        });
      });
    } else {
      const productAlertsRaw = regionObj[selectedProduct] || [];

      const productAlertsFiltered =
        selectedSalesGroup && selectedSalesGroup !== "All"
          ? productAlertsRaw.filter((a) =>
              getSalesGroupFromAlert(a)
                .toString()
                .toUpperCase()
                .includes(selectedSalesGroup.toString().toUpperCase()),
            )
          : productAlertsRaw;

      productAlertsFiltered.forEach((a, idx) => {
        flattened.push({
          id: `${region}-${selectedProduct}-${idx}`,
          severity: mapAlertToSeverity(a),
          alertArrow: a.AlertArrow || "",
          description:
            a.AlertMessage || a.alertMessage || a.description || "",
          raw: a,
          region,
          product: selectedProduct,
        });
      });
    }
  });

  return flattened;
}

export default function KPIAlertTrackingCard({
  title = "KPI / Alert tracking",
  alerts = null,
  selectedProduct = null,
  selectedSalesGroup = null,
  onExplore,
  noGoalsDataAvailable = false,
}) {

  const displayAlerts = flattenKpiAlerts(
    alerts,
    selectedProduct,
    selectedSalesGroup,
  );

  return (
    <NotificationCard
      title={title}
      items={displayAlerts}
      onExplore={onExplore}
      getIcon={(item) => getAlertIcon(item.alertArrow)}
    />
  );
}
